import Box from '@mui/material/Box'
import CancelButton from './TextButtons/CancelButton'
import SaveButton from './TextButtons/SaveButton'

const SaveCancelButtonFooter = ({ saveHandler, cancelHandler, className }) => (
  <Box
    className={className}
    sx={(theme) => ({
      backgroundColor: theme.palette.quaternary.main,
      width: '100%',
      '& button:last-of-type': { marginLeft: '20px' }
    })}
  >
    <CancelButton type='reset' onClick={cancelHandler} />
    <SaveButton type='submit' onClick={saveHandler} />
  </Box>
)

export default SaveCancelButtonFooter
